<template>
  <div style="margin-top:-100%; z-index: 0">
    <div v-if="preferencias.face=='face1' && preferencias.animated == true">
      <lottie :options="face1Options" v-on:animCreated="handleAnimation" />
    </div>

    <div v-if="preferencias.face=='face2' && preferencias.animated == true">
      <lottie :options="face2Options" v-on:animCreated="handleAnimation" />
    </div>

    <img
      v-if="!preferencias.animated"
      :src="'../public/images/arkidians/'+ preferencias.face + '.svg'"
    />
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as face1 from "../../assets/face.json";
import * as face2 from "../../assets/face2.json";

export default {
  name: "app",
  components: {
    lottie: Lottie
  },
  data() {
    return {
      face1Options: {
        animationData: face1,
        loop: true
      },
      face2Options: {
        animationData: face2,
        loop: true
      },

      animationSpeed: 1,
      width: "600"
    };
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
      this.anim.play();
    },

    play: function() {
      this.anim.play();
    }
  },
  props: ["preferencias"],

  mounted: function() {}
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/Face.vue